import React from "react";
import { Route } from "react-router";
import Login from "components/Login";
import { isAuthenticated } from "data/app/appSelectors";
import { State } from "data";
import { useSelector } from "react-redux";
import { RouteProps } from "react-router-dom";

function PrivateRoute(props: RouteProps) {
	const authenticated = useSelector((state: State) => isAuthenticated(state));
	if (!authenticated) return <Login />;

	return <Route {...props} />;
}

export default PrivateRoute;
